import React, { useEffect, useState } from "react";
import { getUserPurchaseHistory } from "../../api/user/user";
import localizationStrings from "../../statics/localization";
import moment from "moment";
import { getSettingsCopy } from "../settings/SettingsFrame";
import CinemaIcon from "../cinema/CinemaIcon";
import "./PurchaseHistory.scss";
export default function PurchaseHistory() {
  const copy = getSettingsCopy(),
    [purchases, setPurchases] = useState([]),
    [months, setMonths] = useState(6),
    [status, setStatus] = useState("loading"),
    [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true;
    setStatus("loading");
    getUserPurchaseHistory()
      .then(({ data }) => {
        if (!active) return;
        setPurchases(Array.isArray(data) ? data : []);
        setStatus("ready");
      })
      .catch(() => {
        if (active) setStatus("error");
      });
    return () => {
      active = false;
    };
  }, [retry]);
  const visible = purchases.filter((item) =>
    moment(item.startDate).isSameOrAfter(moment().subtract(months, "months"))
  );
  return (
    <div className="purchase-history-container">
      <div className="settings-container">
        <label className="settings-period">
          <span>{copy.period}</span>
          <select
            value={months}
            onChange={(e) => setMonths(Number(e.target.value))}
          >
            {[1, 3, 6, 12, 24].map((month) => (
              <option key={month} value={month}>
                {localizationStrings.formatString(
                  localizationStrings.purchaseFilter,
                  {
                    count: String(month >= 12 ? month / 12 : month),
                    format:
                      month >= 12
                        ? localizationStrings.payment.year
                        : localizationStrings.payment.month
                  }
                )}
              </option>
            ))}
          </select>
        </label>
        {status === "loading" ? (
          <div className="settings-empty" role="status">
            {localizationStrings.loading || "Loading…"}
          </div>
        ) : status === "error" ? (
          <div className="settings-empty" role="alert">
            <p>{copy.loadError}</p>
            <button
              className="plan-detail-btn"
              onClick={() => setRetry((v) => v + 1)}
            >
              {copy.retry}
            </button>
          </div>
        ) : !visible.length ? (
          <div className="settings-empty">
            <CinemaIcon name="history" />
            <h2>{copy.emptyPurchase}</h2>
            <p>{copy.emptyPurchaseNote}</p>
          </div>
        ) : (
          <ul className="list">
            {visible.map((item) => (
              <li
                className="li"
                key={`${item.purchaseType}-${item.contentId}-${item.startDate}`}
              >
                <div className="record-info-box">
                  <div className="info-row">
                    <img
                      src={item.posterUrl}
                      alt={item.contentName}
                      className="record-posterUrl"
                    />
                    <div className="info-row0">
                      <div className="info-row1">
                        <label>{item.contentName}</label>
                        <label>{item.price} ₺</label>
                      </div>
                      <div className="info-row2">
                        <span className="span">
                          {moment(item.startDate).format("DD.MM.YYYY HH:mm")}
                        </span>
                        <span className="dot" />
                        <span className="span">
                          {item.endDate
                            ? moment(item.endDate).format("DD.MM.YYYY HH:mm")
                            : item.purchaseType === "RENT" ? "—" : "∞"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
